// The single source of truth for which screen each menu key renders.
//
// Two shells now mount these screens: the existing Dashboard and the redesigned
// ShellV2. Keeping the mapping here rather than in a switch inside each shell means
// adding a screen is one edit, not two that drift apart.
//
// This registry serves the v1 shell only. v2 owns its own screens and its own routing
// under src/v2, so the two interfaces never share a component.
import OrganizationList from './OrganizationList';
import JSONFileUploader from './JsonFileUploader';
import ScannerPage from './LDomainScan';
import LWidget from './LWidgetCreator';
import DownloadPage from './DownloadPage';
import AdminPanel from './AdminPanel';
import Profile from './Profile';
import FeatureRequestBoard from './FeatureRequestBoard';
import TemplateHub from './TemplateHub';
import NotificationsScreen from './NotificationsScreen';

export const DEFAULT_SCREEN = 'Home';

// `props` receives the /me payload so a screen can pull what it needs without every
// shell having to know which screens want which fields.
export const SCREENS = {
  Home:            { component: OrganizationList, props: (d) => ({ isAdmin: d?.isadmin }) },
  Upload:          { component: JSONFileUploader,    props: () => ({}) },
  DomainScanner:   { component: ScannerPage,         props: () => ({}) },
  WidgetCreator:   { component: LWidget,             props: () => ({}) },
  Downloads:       { component: DownloadPage,        props: () => ({}) },
  Adminpanel:      { component: AdminPanel,          props: () => ({}) },
  ReportTemplates: { component: TemplateHub,         props: () => ({}) },
  Profile:         { component: Profile,             props: (d) => ({ username: d?.name, email: d?.email, tenantLogo: d?.tenant_logo }) },
  Request:         { component: FeatureRequestBoard, props: (d) => ({ username: d?.name, email: d?.email }) },
  // The notification footer has always set this key, but no case existed for it, so
  // clicking a notification silently landed on the organization list instead.
  Notifications:   { component: NotificationsScreen, props: () => ({}) },
};

// Resolve a menu key to { Component, props }. An unknown key falls back to the default
// screen *with its props intact* — the old switch dropped isAdmin on the default
// branch, so an unrecognised key quietly downgraded an admin's organization list.
export function resolveScreen(key, dashboardData) {
  const entry = SCREENS[key] || SCREENS[DEFAULT_SCREEN];
  return { Component: entry.component, props: entry.props(dashboardData) };
}
